@if (categoryId) {
  <app-edit-category-form [categoryId]="categoryId" />
}
